import { render, staticRenderFns } from "./AddVisitObjectPopup.vue?vue&type=template&id=3cb45cbf&scoped=true&"
import script from "./AddVisitObjectPopup.vue?vue&type=script&lang=js&"
export * from "./AddVisitObjectPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddVisitObjectPopup.vue?vue&type=style&index=0&id=3cb45cbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb45cbf",
  null
  
)

export default component.exports